import { SafetyCertificateOutlined } from '@ant-design/icons';
import { type RichiestaModuloDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaModuloDTO.ts';
import { SignerHeader } from '@framework/frontoffice-submission/submission/signer/SignerHeader.tsx';
import { SummaryDetailCard } from '@framework/ui/components/summary/SummaryDetailCard.tsx';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { SubmissionValidationAlert } from './SubmissionValidationAlert.tsx';
import { useSubmissionValidation } from './useSubmissionValidation.ts';

const ValidateButton = styled(Button)`
  &&& {
    width: 100%;
  }
`;

export interface ISubmissionValidationCardProps {
  submissionId: string;
  modules?: RichiestaModuloDTO[];
}

/**
 * Card per la Procedura di Verifica Formale dell'Istanza della Richiesta.
 * Visibile solo per domande AgID SUAP con modalità riepilogo estesa.
 */
export function SubmissionValidationCard(
  props: ISubmissionValidationCardProps,
) {
  const { submissionId, modules } = props;
  const { t } = useTranslation();
  const { validate, result, isLoading } = useSubmissionValidation(submissionId);

  return (
    <SummaryDetailCard>
      <SignerHeader
        icon={<SafetyCertificateOutlined aria-hidden="true" />}
        title={t(
          'form.validazione-card-titolo',
          "Procedura di Verifica Formale dell'Istanza della Richiesta",
        )}
        description={t(
          'form.validazione-card-descrizione',
          "Fare click sul pulsante dedicato per avviare la validazione formale dell'istanza.",
        )}
      />

      {result && (
        <SubmissionValidationAlert
          submissionId={submissionId}
          result={result}
          modules={modules}
        />
      )}

      <ValidateButton
        icon={<SafetyCertificateOutlined />}
        size="large"
        loading={isLoading}
        onClick={validate}
      >
        {t('form.valida-istanza', 'Valida Istanza')}
      </ValidateButton>
    </SummaryDetailCard>
  );
}
